import { useContext } from "react";
import { getStock } from "../../../helpers/product";
import { updateCartItem } from "../../../redux/actions/cartActions";
import { AuthContext } from "../../../common/Auth";

export const useProductSourceState = (props) => {
    const {dtsInventoryStock, cartProducts, isStock, inventoryStock} = props;
    const {ipV4} = useContext(AuthContext)

    const setItemSource = () => {
        cartProducts.length > 0 && cartProducts.map(async(cardProduct, key) => {
            let dtsInventoryProduct = [];
            dtsInventoryStock.forEach(dtsInventoryArray => {
                dtsInventoryArray.forEach(dtsInventory => {
                    if(dtsInventory.productId === cardProduct?.product?.productId) {
                        dtsInventoryProduct = dtsInventoryArray;
                    }
                })
            })
            const productId = cardProduct.product?.id
            const isStockFor = !!!cardProduct.product?.isStockFor || cardProduct.product.isStockFor === 'globalsetting' ? isStock : cardProduct.product.isStockFor
            cardProduct.currentOrder.forEach(currentOrder => {
                let updatedSource = cardProduct.source;
                currentOrder.forEach(product => {
                    let stockData = getStock(product.size, product.color,
                        inventoryStock.find(x => productId === x.id?.toString()) || {},
                        cardProduct?.product,
                        dtsInventoryProduct,
                        isStockFor);
                    if(Number(product.quantity) <= Number(stockData)) {
                        updatedSource = cardProduct.product?.poType || 'Stock'
                    } else {
                        updatedSource = 'DropShip'
                    }
                })
                updateCartItem({...cardProduct, source: updatedSource}, ipV4)
            })
        });
    }

    return {
        setItemSource
    }
}
